<template>
  <div id="note-graph-view">
    <graph :key="current_workspace.slug" />
  </div>
</template>

<script>
import Graph from '../components/Graph.vue'
export default {
    components: { Graph },
    data() {
        return {

        }
    },
  
    computed: {
        current_workspace() {
            return this.$store.getters.current_workspace;
        }
    },
    
   
}

</script>
<style lang="sass" scoped>

    #note-graph-view
        display: grid
        template-grid-rows: 1fr
        template-grid-columns: 1fr
        overflow: hidden




    
</style>
